<!-- <p>inventory-details-card works!</p> -->
<div class="mobile-table-card-wrapper">
  <div
    *ngFor="let item of inventory; let i = index"
    class="mobile-table-card-container"
  >
    <div class="card-content">
      <div>
        Serial No.: <b>{{ i + 1 }}</b>
      </div>
      <div>
        Inventory Id : <b>{{ item.inventoryId }}</b>
      </div>
      <div>
        List Name : <b>{{ item.listName }}</b>
      </div>
      <div>
        Delivery Date : <b>{{ item.deliveryDate | date }}</b>
      </div>
      <div>
        Total Items : <b>{{ item.inventoryItems.length }}</b>
      </div>
    </div>
    <div class="card-action">
      <button (click)="onShowDetails(item)" mat-raised-button>
        {{
          clickedItem?.inventoryId === item.inventoryId ? "Close" : "Details"
        }}
      </button>
    </div>
  </div>
</div>
